<template>
    <el-dialog :visible.sync="user.loginDlog" width="500px" :before-close="handleClose" :style="{ zIndex: 3000 }">
        <div class="login-container">
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on"
                label-position="left">
                <div class="logo_login">
                    <img src="../assets/logo_main.png" alt="">
                </div>
                <div class="title-container">
                    <h3 class="title">登录</h3>
                </div>
                <el-form-item prop="account">
                    <el-input prefix-icon="el-icon-user-solid" ref="username" v-model="loginForm.account"
                        placeholder="账号" name="username" type="text" tabindex="1" auto-complete="on" />
                </el-form-item>
                <el-form-item prop="password">
                    <el-input prefix-icon="el-icon-lock" v-model="loginForm.password" placeholder="密码" name="password"
                        tabindex="2" auto-complete="on" @keyup.enter.native="handleLogin" show-password />
                </el-form-item>

                <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;"
                    @click.native.prevent="handleLogin">登录</el-button>
            </el-form>
        </div>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'Header',
  computed: mapState(['user']),
  data () {
    return {
      loading: false,
      loginForm: {
        account: '',
        password: ''
      },
      loginRules: {
        account: [{ required: true, trigger: 'blur', message: '账号不可为空' }],
        password: [{ required: true, trigger: 'blur', message: '密码不可为空' }]
      }
    }
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('user/login', this.loginForm).then(() => {
            this.upDateUser()
            this.loginForm = {
              account: '',
              password: ''
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    upDateUser () {
      this.$store.dispatch('user/getInfo').then(() => {
        this.loading = false
        this.$store.dispatch('user/checkAgree')
        this.$message({
          type: 'success',
          message: '登录成功'
        })
      }).catch(() => {
        this.loading = false
      })
    },
    handleClose (done) {
      done()
    },
    loginDo () {
      this.$router.push('/login')
    },
    goHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
    padding: 26px 0;
    text-align: center;
}

.logo_login {
    display: flex;
    justify-content: center;
}

.logo_login img {
    width: 140px;
    object-fit: contain;
}
</style>
